export default {
  de: {
    translation: {
      Index: {
        applicationLoadErrorMessage: 'Fehler beim Laden der Applikation',
        applicationLoadErrorDescription: 'Die Applikation mit der ID {{applicationId}} konnte nicht geladen werden. ' +
          'Die Standardkonfiguration wird stattdessen geladen.',
        errorMessage: 'Fehler beim Laden der Applikation',
        errorDescription: 'Aufgrund eines unerwarteten Fehlers konnte die Applikation nicht geladen werden. ' +
          'Bitte laden Sie die Seite erneut.'
      },
      Header: {
        title: 'Kinderarmut an Schulen',
        mapButtonText: 'Karte'
      },
      MapPane: {
        layerTreeDrawerTitle: 'Themen',
        featureInfoDrawerTitle: 'Abfrage'
      },
      LayerTreeNode: {
        noLegendAvailable: 'Keine Legende verfügbar',
        toggleLegendTooltipHideTitle: 'Legende ausblenden',
        toggleLegendTooltipShowTitle: 'Legende anzeigen'
      },
      FeatureInfo: {
        usageHint: 'Klicken Sie in die Karte, um Detailinformationen zu erhalten.'
      },
      FeatureInfoPropertyGrid: {
        key: 'Attribut',
        value: 'Wert'
      },
      Nominatim: {
        placeholder: 'Ortsname, Straßenname, Stadtteilname, POI usw.'
      },
      Drawer: {
        title: 'Themen'
      },
      Footer: {
        scaleComboLabel: 'Maßstab',
        versionLabel: 'Version',
        imprint: '© 2023 Wissenschaftszentrum Berlin für Sozialforschung',
        imprintLinkText: 'Impressum'
      },
      PrintButton: {
        pdfTitle: 'WZB Webkarte',
        pdfLegendTitle: 'Legende',
        tooltip: 'Kartenausschnitt als PDF exportieren'
      },
      ToggleFeatureInfoButton: {
        tooltip: 'Kartenobjekte abfragen'
      },
      ToggleLayerTreeButton: {
        tooltip: 'Themenbaum zeigen/verbergen'
      }
    }
  },
  en: {
    translation: {
      Index: {
        applicationLoadErrorMessage: 'Error while loading the application',
        applicationLoadErrorDescription: 'The application with ID {{applicationId}} could not be loaded correctly. ' +
          'You\'re seeing the default application configuration.',
        errorMessage: 'Error while loading the application',
        errorDescription: 'An unexpected error occured while loading the application. Please try to reload the page.'
      },
      Header: {
        title: 'Child poverty in schools',
        mapButtonText: 'Map'
      },
      MapPane: {
        layerTreeDrawerTitle: 'Layers',
        featureInfoDrawerTitle: 'Feature info'
      },
      LayerTreeNode: {
        noLegendAvailable: 'No legend available',
        toggleLegendTooltipHideTitle: 'Hide legend',
        toggleLegendTooltipShowTitle: 'Show legend'
      },
      FeatureInfo: {
        usageHint: 'Click on the map to get details about the clicked coordinate.'
      },
      FeatureInfoPropertyGrid: {
        key: 'Attribute',
        value: 'Value'
      },
      Nominatim: {
        placeholder: 'Place name, street name, district name, POI, etc.'
      },
      Drawer: {
        title: 'Layers'
      },
      Footer: {
        scaleComboLabel: 'Scale',
        versionLabel: 'Version',
        imprint: '© 2023 Berlin Social Science Center',
        imprintLinkText: 'Imprint'
      },
      PrintButton: {
        pdfTitle: 'WZB Webkarte',
        pdfLegendTitle: 'Legend',
        tooltip: 'Export map as PDF'
      },
      ToggleFeatureInfoButton: {
        tooltip: 'Query map features'
      },
      ToggleLayerTreeButton: {
        tooltip: 'Show/hide layer tree'
      }
    }
  }
};
